import { FloatingVueConfig } from 'floating-vue/dist/config';
import { App } from 'vue';

export const floatingVueConfig = {
  overflowPadding: 8,
  themes: {
    'atlasti-dropdown': {
      $extend: 'dropdown',
      $resetCss: true,
      distance: 8,
      eagerMount: false,
      disposeTimeout: 500,
    },
    'atlasti-tooltip': {
      $extend: 'tooltip',
      $resetCss: true,
      distance: 8,
      eagerMount: false,
      disposeTimeout: 500,
      delay: {
        show: 50,
        hide: 0,
      },
    },
  },
} as const satisfies FloatingVueConfig;

export const registerComponent = (app: App, component, name: string) => app.component(name, component);
export const registerComponents = (app: App, components) => {
  Object.entries(components).forEach(([name, component]) => registerComponent(app, component, name));
};
